<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="角色名称：" prop="rolename">
                <el-input v-model="model.rolename"></el-input>
            </el-form-item>
            <el-form-item label="角色类型：" prop="role_type">
                <el-select clearable v-model="model.role_type" placeholder="请选择">
                    <el-option v-for="item in enuObj('role_type')" :key="'role_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="技术服务人员：" prop="is_jishu">
                <el-select clearable v-model="model.is_jishu" placeholder="请选择">
                    <el-option v-for="item in enuObj('yesNo')" :key="'yesNo'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="顺序：" prop="order_index">
                <el-input v-model.number="model.order_index" style="width: 192px"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: "roleEdit",
    mixins: [editutil],
    data() {
        return {
            exits_p_name:'rolename',
            exits_p_title:'角色名称',
            model: {
                rolename: '',
                order_index: '',
                role_type: '',
                is_jishu: '',
            },
            getObj:{
                url:'/api/admin/role/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            checkObj:{
                url:'/api/admin/role/check',
                data:{}
            },
            rules: {
                rolename: [
                    {required: true, message: '角色名称不能为空', trigger: 'blur'},
                    {validator: this.validExist, trigger: 'blur' }
                ],
                role_type: [
                    {required: true, message: '角色类型不能为空', trigger: 'blur'},
                ],
                is_jishu: [
                    {required: true, message: '技术服务人员不能为空', trigger: 'blur'},
                ],
                order_index: [
                    {required: true, message: '顺序不能为空', trigger: 'blur'},
                    {type: 'number', message: '顺序必须是数字值', trigger: 'blur'}
                ],
            },
            enu_name: ['role_type', 'yesNo'],
        }
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/role/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                    
                }
            })
        },
        formateData(){
            this.model.role_type = this.model.role_type+""
            this.model.is_jishu = this.model.is_jishu+""
        },
    }
};
</script>